import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import useSelector from 'hooks/useSelector';
import { jwtDecodedSelector } from 'store/user/selectors';
import { UserRoleEnum } from 'common/user/enums/user-role.enum';
import { isValidTokenByRoleHelper } from './helpers/is-valid-token-by-role.helper';
import { DriverLogoutPage } from 'routes/paths';

type InputProps = {
  children: JSX.Element;
};

export const DriverGuard = ({ children }: InputProps) => {
  const location = useLocation();
  const accessToken = useSelector(jwtDecodedSelector);

  return isValidTokenByRoleHelper(UserRoleEnum.CANDIDATE, accessToken) ? (
    children
  ) : (
    <Navigate
      to={DriverLogoutPage}
      replace
      state={{ path: location.pathname }}
    />
  );
};
